const SHARED_BODY = [
  { text: 'Your answer should be a reasoned and substantiated argument that justifies your response to the question.' },
  { text: 'You may use the erasable notebook for planning your essay.' },
  { text: 'Your answer should ideally be between 500 and 600 words.' },
];

export function buildLnatSectionBInstructionBody(n) {
  const count = Number(n) || 0;
  if (count <= 1) {
    return [
      { text: 'Answer the essay question.', bold: true },
      { text: 'You must only respond to this question.', bold: true },
      ...SHARED_BODY,
    ];
  }
  if (count === 3) {
    return [
      { text: 'Answer ONE of the following essay questions.', bold: true },
      { text: "You can use the 'Next' and 'Previous' buttons to view all questions before selecting the one you wish to answer." },
      { text: 'You must only respond to ONE question. Do not write answers for more than one question. Leave the other two questions completely blank.', bold: true },
      ...SHARED_BODY,
    ];
  }
  return [
    { text: `Answer ONE of the following ${count} essay questions.`, bold: true },
    { text: "You can use the 'Next' and 'Previous' buttons to view all questions before selecting the one you wish to answer." },
    { text: 'You must only respond to ONE question. Do not write answers for more than one question. Leave all other questions completely blank.', bold: true },
    ...SHARED_BODY,
  ];
}

export function lnatEssayOneResponseMessage(n) {
  const count = Number(n) || 0;
  if (count <= 1) {
    return 'You must respond to the essay question.';
  }
  if (count === 3) {
    return 'You must only respond to ONE question. Leave the other two blank.';
  }
  return 'You must only respond to ONE question. Leave all other questions completely blank.';
}

export function lnatEssayEndReviewMessage(n) {
  const count = Number(n) || 0;
  if (count <= 1) {
    return 'You must write an essay before ending review.';
  }
  if (count === 3) {
    return 'You must write an essay for one of the three questions before ending review. Leave the other two blank.';
  }
  return 'You must write an essay for one of the questions before ending review. Leave all other questions blank.';
}

/** LNAT empty→0; TSA empty→1. Do not apply LNAT empty→3. */
export function lnatOrTsaPaper2InstructionCount(paper2Length, { isLnatExam, isTaraTsaSitting } = {}) {
  const n = Number(paper2Length) || 0;
  if (isLnatExam) return n;
  if (isTaraTsaSitting) return n || 1;
  return n || 20;
}
